<template>
  <v-container fluid style="width: 100%" class="px-5">
    <div v-if="$route.name === names.FOULS.LIST">
      <v-toolbar
          class="removeBtnPaddingRight rounded-t-lg"
          color="#DADADA"
          flat
      >
        <v-text-field
            clearable
            outlined
            dense
            single-line
            :disabled="isLoading"
            v-model="search.value" label="Поиск" hide-details @keydown.enter="searchData" @click:clear="clearSearchData">
        </v-text-field>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-data-table
          :headers="headers"
          :items="items"
          :loading="isLoading"
          :page.sync="pagination.page"
          :items-per-page.sync="pagination.size"
          :server-items-length="count"
          :options.sync="options"
          :footer-props="{'items-per-page-options':[10,50,100]}"
          class="elevation-1 rounded-b-lg"
      >
        <template v-slot:item.car="{ item }">
          <span v-if="item.car"><span class="font-weight-bold blue--text text--darken-3">{{ item.car.model }}</span> {{ item.car.number }}</span>
          <span v-else>-</span>
        </template>
        <template v-slot:item.designer="{ item }">
          <span v-if="item.designer">{{ item.designer.fio }}</span>
          <span v-else>-</span>
        </template>
        <template v-slot:item.enter_time="{ item }">
          <span v-if="item.enter_time">{{ displayDate(item.enter_time, true) }}</span>
          <span v-else>-</span>
        </template>
        <template v-slot:item.exit_time="{ item }">
          <span v-if="item.exit_time">{{ displayDate(item.exit_time, true) }}</span>
          <span v-else>-</span>
        </template>
        <template v-slot:item.foul_time="{ item }">
          <span v-if="item.foul_time">{{ item.foul_time }}</span>
          <span v-else>-</span>
        </template>
        <template v-slot:no-data>
          <v-btn
              color="primary"
              @click="loadData()"
          >
            Обновить
          </v-btn>
        </template>
      </v-data-table>
    </div>
    <router-view v-else></router-view>
  </v-container>
</template>

<script>
import names from "../routers/names";
import TitledPageMixin from "@/mixins/TitledPageMixin";
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";
import {mapActions, mapGetters} from "vuex";
import entitled from "@/urls/roles/entitled";
import names_core from "@/modules/core/routers/names";
import {displayDate} from "@/helper";
export default {
  name: "FoulsList",
  mixins: [TitledPageMixin, PaginatedDataMapperMixin],
  data() {
    return {
      page_title: "Список нарушений",
      headers: [
        {text: "Номер заявки", value: "order_number", align: "start", sortable: false, width: "10%"},
        {text: "Авто", value: "car", align: "start", sortable: false, width: "10%"},
        {text: "Инициатор", value: "designer", align: "start", sortable: false, width: "20%"},
        {text: "Время въезда", value: "enter_time", align: "center", sortable: false, width: "15%"},
        {text: "Время выезда", value: "exit_time", align: "center", sortable: false, width: "15%"},
        {text: "Время опоздания", value: "foul_time", align: "center", sortable: false, width: "15%"}
      ],
      search: {
        parameter: "search"
      },
    }
  },
  computed: {
    names: () => names,
    ...mapGetters({
      items: "entitled/getFoulsList",
      count: "entitled/getFoulsCount",
      isLoading: "entitled/isLoadingFouls",
      getCurrentUrl: "entitled/getFoulsCurrentUrl"
    })
  },
  methods: {
    ...mapActions({
      loadFoulsList: "entitled/loadFoulsList"
    }),
    displayDate: displayDate,
    loadData(url = undefined) {
      this.loadFoulsList({
        url: url,
        urlAppend: (url) => {
          let new_url = this.addPageParameter(this.addSizeParameter(url))
          if (this.search.value)
            new_url = this.addGetParameter(new_url, "search", this.search.value)
          return new_url
        },
        finalizer: (data, url) => {
          this.setCurrentLoadUrl(url);
        }
      })
    }
  },
  created() {
    if (entitled.ENTITLED.ALLOWED()){
      if (this.getCurrentUrl) {
        this.loadFromSavedUrl(this.getCurrentUrl)
      } else {
        this.loadData()
      }
    }
    else{
      this.$router.push({name: names_core.MAIN}).catch(() => {})
    }
  }
}
</script>

<style scoped>
.removeBtnPaddingRight>>>.v-toolbar__content{
  padding-right: 0px;
}
</style>
